var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "50%",
    x2: "54.584%",
    y1: "29.143%",
    y2: "70.857%"
  }, "\r\n            {/* Set gradient color */}\r\n            ", /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DC3545"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-1)",
    d: "M62,-48.7C78.1,-29.3,87.4,-3.6,82.3,18.9C77.2,41.3,57.9,60.6,34.5,72C11.2,83.3,-16.1,86.7,-38.7,77C-61.3,67.4,-79.3,44.8,-84.8,19.6C-90.4,-5.6,-83.6,-33.4,-67.4,-52.9C-51.2,-72.4,-25.6,-83.5,-1.3,-82.5C23,-81.4,45.9,-68.2,62,-48.7Z",
    transform: "translate(100 100)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.13d3b693452e207b70d0755790ee0a9a.svg";
export { ForwardRef as ReactComponent };